"use strict";
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var GridInteractionHandle = require("./gridInteractionHandle.js");
var AbstractPosAngleInteractionModel = require("./abstractPosAngleInteractionModel.js");
var TextInteractionModel = require("../extensions/svg/textViewer/textInteractionModel.js");
var SnapSet = require("./../extensions/snap/snapSet.js");

var GridInteraction = {
    addGridInteraction : function (collection, editorModel) {
        var self = this;

        this.singleElement = false;
        if(collection.getType && collection.getType() === "set") {
            this.collection = collection;
        } else {
            this.singleElement = true;
            this.collection = this.set("collection", false);
            this.collection.add(collection);
        }
        this.editorModel = editorModel;

        this.hidden = this.value("hidden", true);
        this.hidden(this.collection.size() < 2);

        this.boundingBox = this.shadow("selectionGridBoundingBox",
            function () {
                if(self.singleElement && self.collection.size() === 1) {
                    var element = self.collection.getOne().data;
                    var cx = element.pos().x;
                    var cy = element.pos().y;
                    var width = element.width();
                    var height = element.height();
                    return element.constructor.calculateBoundingBox(cx, cy, width, height, 0);
                } else {
                    var boundingBox = lib_geometry.BoundingBox.emptyBoundingBox;
                    self.collection.forEach(function(element) {
                        if(element.data && element.data.boundingBox) {
                            var bb = element.data.boundingBox && element.data.boundingBox();
                            if (bb) boundingBox = bb.merge(boundingBox);
                        }
                    });
                    return boundingBox;
                }
            },
            null,
            [this.collection]
        );

        this.gPos = this.value("gPos", true);
        this.gWidth = this.value("gWidth", true);
        this.gHeight = this.value("gHeight", true);
        this.gAngle = this.value("gAngle", true);
        this.gXflip = this.value("gXflip", true);
        this.gYflip = this.value("gYflip", true);

        // 9 handles
        this.handles = this.list("handles", true);

        this.precision = 1e-6;

        this.handleMoving = false;

        this.aspectRatio = 1;

        this.origObjectRatios = new lib_core.Collections.HashMap();

        // add the 9 handles, store as 1-9 at index 0-8
        for (var i = 0; i < 9; i++) {
            this.handles.add(i, new GridInteractionHandle(this, i + 1));
        }

        this.collection.forEach(function (ignore, element) {
            self.boundingBox.addTrigger(element.data.boundingBox);
            self.setupObjPropListeners(element);
        }, 10);

        this.collection.onAdd(this, function (element) {
            self.boundingBox.addTrigger(element.data.boundingBox);
            self.editorModel.heavyHandler.scheduleHeavy('update_grid', self.update, self, [], self);
            self.setupObjPropListeners(element);

            // TODO: this is a bit of a hack :/
            if(!self.singleElement) {
                if (self.collection.size() < 2) self.hidden(true);
                else self.hidden(false);
            }
        }, 10);

        this.collection.onRemove(this, function (element) {
            self.boundingBox.removeTrigger(element.data.boundingBox);
            self.editorModel.heavyHandler.scheduleHeavy('update_grid', self.update, self, [], self);

            // TODO: this is a bit of a hack :/
            if(!self.singleElement) {
                if (self.collection.size() < 2) self.hidden(true);
                else self.hidden(false);
            }
        }, 10);

        this.boundingBox.onChange("dataChanged", function () {
            if(!self.handleMoving && !self.hidden()) {
                // self.editorModel.heavyHandler.scheduleHeavy('update_grid', self.update, self, [], self);
                self.update();
            }
        }, 10);

        if(this.singleElement) { // TODO: Hacky
            this.infocus.onChange(this, function (value) {
                self.hidden(!value);
            });
        }

        this.hidden.onChange(this, function () {
            self.update();
        }, 10);

        this.update();
    },

    update : function() {
        var self = this;

        if(!this.hidden()) {
            if(this.collection.size() === 0) {
                this.gPos(new lib_geometry.Coord(0,0));
                this.gWidth(0);
                this.gHeight(0);
                this.gAngle(0);
                this.gXflip(false);
                this.gYflip(false);
            } else {
                this.gPos(this.boundingBox().getCenter());
                this.gWidth(this.boundingBox().width);
                this.gHeight(this.boundingBox().height);
                this.gAngle(0);
                this.gXflip(false);
                this.gYflip(false);
            }
            this.gHdiff = 0;
            this.gWdiff = 0;

            if (this.singleElement && this.collection.size() === 1) {
                this.gAngle(this.collection.getOne().data.angle());
            }

            this.collection.forEach(function (objIntModel, idx) {
                self.updateRatios(objIntModel, true);
            });

            this.aspectRatio = 1;
            if (this.gHeight() !== 0 && this.gWidth() !== 0) {
                this.aspectRatio = this.gWidth() / this.gHeight();
            }
        }
        this.updateAllHandles();
    },

    updateGrid : function(pos, width, height, xflip, yflip) {
        var self = this;

        var vec = pos.sub(this.gPos());

        this.collection.forEach(function (el) {
            var origRatio = self.origObjectRatios.get(el);
            var elPos = pos.add(new lib_geometry.Coord(origRatio.posXtoWidth * parseFloat(width), origRatio.posYtoHeight * parseFloat(height)));
            el.pos(elPos);
        });

        this.gWdiff += width-this.gWidth();
        this.gHdiff += height-this.gHeight();

        this.drillDownWH(width, height);

        if(xflip !== undefined && xflip !== this.gXflip()) {
            var flipLine = new lib_geometry.Line(lib_geometry.Line.VER.rotate(this.gAngle()), pos);
            this.drillDownFlip(flipLine);
        }
        if(yflip !== undefined && yflip !== this.gYflip()) {
            var flipLine = new lib_geometry.Line(lib_geometry.Line.HOR.rotate(this.gAngle()), pos);
            this.drillDownFlip(flipLine);
        }

        if(pos !== undefined) this.gPos(pos);
        if(width !== undefined) this.gWidth(width);
        if(height !== undefined) this.gHeight(height);
        if(xflip !== undefined) this.gXflip(xflip);
        if(yflip !== undefined) this.gYflip(yflip);

        this.updateAllHandles();
    },

    unhighlightAllExcept : function(index) {
        for (var i = 0; i < 9; i++) {
            if(i+1 !== index) this.handles.get(i).highlighted(false);
        }
    },

    setupObjPropListeners : function(objIntModel) {
        var self = this;
        if(objIntModel.data && objIntModel.data.angle && objIntModel.data.angle.onChange) {
            objIntModel.data.angle.onChange("objIntModel.data.angle.onChange", function() {
                // unfortunately, we need to update w,h ratios in case of a flip operation
                // which causes an angle change
                self.updateRatios(objIntModel, false);
            });
        }
    },

    updateRatios : function(objIntModel, forceNewPosRatio) {
        var self = this;

        if(this.handleMoving) return;

        // each object in the selection will have an array of ratios comparing position and size to the
        // multiselect box position and size, taking angle into account
        var ratioObj = self.origObjectRatios.get(objIntModel);
        if(ratioObj == undefined) {
            forceNewPosRatio = true;
            ratioObj = {
                posXtoWidth: null,
                posYtoHeight: null,
                ratio_Wx_W: null,
                ratio_Wy_H: null,
                ratio_Hy_H: null,
                ratio_Hx_W: null
            };
        }

        // we need to avoid infinitely large numbers when dividing by w,h
        if(self.gWidth() > self.precision && self.gHeight() > self.precision) {
            if (objIntModel.pos && (forceNewPosRatio)) {
                ratioObj.posXtoWidth = objIntModel.pos().sub(self.gPos()).getX() / self.gWidth();
                ratioObj.posYtoHeight = objIntModel.pos().sub(self.gPos()).getY() / self.gHeight();
            }

            if (objIntModel.width && objIntModel.height && objIntModel.angle) {
                var angle = objIntModel.angle() - this.gAngle();
                var rotatedWidth = new lib_geometry.Coord(objIntModel.width(), 0)
                    .rotate(angle);
                var rotatedHeight = new lib_geometry.Coord(0, objIntModel.height())
                    .rotate(angle);

                ratioObj.ratio_Wx_W = rotatedWidth.getX() / self.gWidth();
                ratioObj.ratio_Wy_H = rotatedWidth.getY() / self.gHeight();
                ratioObj.ratio_Hy_H = rotatedHeight.getY() / self.gHeight();
                ratioObj.ratio_Hx_W = rotatedHeight.getX() / self.gWidth();
            }
        }

        self.origObjectRatios.put(objIntModel, ratioObj);
    },

    updateAllHandles : function () {
        this.handles.forEach(function (idx, obj) {
            obj.update();
        });
    },

    drillDownWH : function (width, height) {
        var self = this;

        this.collection.forEach(function (objIntModel, idx) {
            if(objIntModel.width && objIntModel.height) { // some shapes do not have this
                var angle = objIntModel.angle() - self.gAngle();
                var angleRadians = angle*Math.PI / 180.0;
                var cosVal, sinVal;

                cosVal = Math.abs(Math.cos(angleRadians));
                sinVal = Math.abs(Math.sin(angleRadians));

                var origRatio = self.origObjectRatios.get(objIntModel);
                var ratio_Wx_W = Math.abs(origRatio.ratio_Wx_W),
                    ratio_Wy_H = Math.abs(origRatio.ratio_Wy_H),
                    ratio_Hx_W = Math.abs(origRatio.ratio_Hx_W),
                    ratio_Hy_H = Math.abs(origRatio.ratio_Hy_H);

                var newHeight;
                var newWidth;
                newWidth = width * (ratio_Wx_W);
                if(Math.abs(cosVal) > self.precision) {
                    objIntModel.width(newWidth / cosVal);
                }
                newHeight = height * (ratio_Hy_H);
                if(Math.abs(cosVal) > self.precision) {
                    objIntModel.height(newHeight / cosVal);
                }

                if(Math.abs(self.gWdiff) > Math.abs(self.gHdiff)) {
                    newHeight = width * (ratio_Hx_W);
                    if(Math.abs(sinVal) > self.precision) {
                        objIntModel.height(newHeight / sinVal);
                    }
                }
                if(Math.abs(self.gWdiff) < Math.abs(self.gHdiff)) {
                    newWidth = height * (ratio_Wy_H);
                    if(Math.abs(sinVal) > self.precision) {
                        objIntModel.width(newWidth / sinVal);
                    }
                }
            }
        });
    },

    drillDownFlip : function (flipLine) {
        var self = this;
        var horizOrVert = flipLine.dir.eq(lib_geometry.Line.VER);

        this.collection.forEach(function (objIntModel, idx) {
            if(objIntModel instanceof TextInteractionModel) {
                objIntModel.data.pos(objIntModel.data.pos().flip(flipLine));
            } else {
                objIntModel.data.flip(flipLine);
            }

            // update ratios without introducing sin/cos rounding errors
            var ratio = self.origObjectRatios.get(objIntModel);
            if(horizOrVert) {
                // horizontal flip
                ratio.posXtoWidth *= -1.0;
                ratio.ratio_Wx_W *= -1.0;
                ratio.ratio_Hx_W *= -1.0;
                self.origObjectRatios.put(objIntModel, ratio);
            } else {
                // vertical flip
                ratio.posYtoHeight *= -1.0;
                ratio.ratio_Wy_H *= -1.0;
                ratio.ratio_Hy_H *= -1.0;
                self.origObjectRatios.put(objIntModel, ratio);
            }
        });
    }
};

module.exports = GridInteraction;
